import { toast } from 'sonner';

type GamificationToastAction = {
  label: string;
  onClick: () => void;
};

type GamificationSingleToastInput = {
  toastId: string;
  title: string;
  body: string;
  action: GamificationToastAction;
  cancel?: GamificationToastAction;
};

export const notify = {
  success: (message: string) => {
    toast.success(message);
  },
  error: (message: string) => {
    toast.error(message);
  },
  info: (message: string) => {
    toast.info(message);
  },
  warning: (message: string) => {
    toast.warning(message);
  },
  voting: {
    submitted: () => toast.success('Vote submitted', { duration: 1800 }),
    removed: () => toast.info('Vote removed', { duration: 1800 }),
    revoteCooldown: (secondsRemaining: number) =>
      toast('Hold on', {
        description: `You can change your pick again in ${secondsRemaining}s.`,
      }),
    revoteFinal5Limit: () =>
      toast('Change limit reached', {
        description: 'In the last 5 minutes before the deadline you can change your pick only once.',
      }),
    revoteNoChangesLeft: () =>
      toast('No changes left', {
        description: 'You\'ve used all changes for this duel.',
      }),
    pickUpdated: (changesLeft: number) =>
      toast.success('Pick updated', {
        description:
          changesLeft === 1 ? '1 change left.' : changesLeft > 1 ? `${changesLeft} changes left.` : undefined,
      }),
  },
  ui: {
    linkCopied: () => toast.success('Link copied to clipboard'),
    linkCopyFailed: () => toast.error('Failed to copy link'),
    inviteCodeCopied: () => toast.success('Invite code copied to clipboard'),
    inviteCodeCopyFailed: () => toast.error('Failed to copy invite code'),
  },
  gamification: {
    single: ({ toastId, title, body, action, cancel }: GamificationSingleToastInput) => {
      toast(title, {
        id: toastId,
        description: body,
        duration: 8000,
        action: {
          label: action.label,
          onClick: action.onClick,
        },
        ...(cancel
          ? {
              cancel: {
                label: cancel.label,
                onClick: cancel.onClick,
              },
            }
          : {}),
      });
    },
    summary: (count: number, action: GamificationToastAction, toastId: string) => {
      toast(`You earned ${count} new things this GW`, {
        id: toastId,
        duration: 8000,
        action: {
          label: action.label,
          onClick: action.onClick,
        },
      });
    },
    shareSuccess: (method: 'web-share' | 'clipboard') => {
      if (method === 'clipboard') {
        toast.success('Achievement copied to clipboard');
        return;
      }
      toast.success('Ready to share');
    },
    shareError: () => {
      toast.error('Could not share this achievement. Please try again.');
    },
  },
};
